import { render, staticRenderFns } from "./recommend-goods.vue?vue&type=template&id=4bf2db08&scoped=true"
import script from "./recommend-goods.vue?vue&type=script&lang=js"
export * from "./recommend-goods.vue?vue&type=script&lang=js"
import style0 from "./recommend-goods.vue?vue&type=style&index=0&id=4bf2db08&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf2db08",
  null
  
)

export default component.exports